import React from 'react';
import PropTypes from 'prop-types';
import noop from 'lodash/noop';
import { TransitionMotion } from 'react-motion';

import ToastMessage from 'modules/messageSystem/components/ToastMessage';

const propTypes = {
  /** list of toast messages */
  toasts: PropTypes.arrayOf(PropTypes.shape({
    testId: PropTypes.string.isRequired,
    /** unique identifier of the message */
    id: PropTypes.string.isRequired,
    /** message in i18n format that will be displayed in toast */
    message: PropTypes.string,
    /** show close button */
    showClose: PropTypes.bool,
    /** show retry button */
    showRetry: PropTypes.bool,
    /** func executes on click retry button */
    onRetry: PropTypes.func,
    showUndo: PropTypes.bool,
    onUndo: PropTypes.func,
    type: PropTypes.oneOf(['info', 'failure', 'success']),
  })),
  /** @type string classname that will be added to container classes */
  containerClassName: PropTypes.string,
  /** define to true for hebrew language */
  rtl: PropTypes.bool,
  /** function to delete toast message by it's id */
  removeToast: PropTypes.func,
  willLeave: PropTypes.func.isRequired,
  willEnter: PropTypes.func.isRequired,
  styleModificator: PropTypes.func.isRequired,
  innerComponent: PropTypes.object,
};
const defaultProps = {
  toasts: [],
  containerClassName: '',
  rtl: false,
  removeToast: noop,
  innerComponent: null,
};

const ToastsPlace = ({ innerComponent, toasts, willLeave, willEnter, styleModificator, removeToast, containerClassName, rtl }) => (
  <div className={ containerClassName }>
    <TransitionMotion
      willLeave={ willLeave }
      willEnter={ willEnter }
      defaultStyles={ toasts.map((item) => ({
        key: item.id,
        style: {
          x: 0,
        },
      })) }
      styles={ styleModificator(toasts) }
    >
      { (interpolatedStyles) => {
        return (
          <div>
            <If condition={ innerComponent }>
              { innerComponent }
            </If>
            { interpolatedStyles.map(({ key, style, data: { testId, message, id, showClose, showRetry, onRetry, hasDuplicate, showUndo, onUndo, autoDismissTime, type } }) => {
              return (
                <ToastMessage
                  testId={ testId }
                  style={{
                    opacity: style.x / 100,
                    transform: `scale(${ style.x / 100 })`,
                  }}
                  key={ key }
                  id={ id }
                  rtl={ rtl }
                  onClose={ () => removeToast(id) }
                  showClose={ showClose }
                  showRetry={ showRetry }
                  onRetry={ onRetry }
                  showUndo={ showUndo }
                  onUndo={ onUndo }
                  hasDuplicate={ hasDuplicate }
                  autoDismissTime={ autoDismissTime }
                  type={ type }
                >
                  { message }
                </ToastMessage>
              );
            }) }
          </div>
        );
      } }
    </TransitionMotion>
  </div>
);

ToastsPlace.propTypes = propTypes;
ToastsPlace.defaultProps = defaultProps;

export default ToastsPlace;
